<template>
  <div class="tf eft">
    <!-- загрузка -->
    <div v-if="isLoadingGames" class="eft-skeleton">
      <span class="eft-sk eft-sk--row"></span>
      <span class="eft-sk eft-sk--row"></span>
      <span class="eft-sk eft-sk--logo"></span>
      <span class="eft-sk eft-sk--row"></span>
    </div>

    <b-form v-else @submit="submitForm">

      <!-- ============ команда ============ -->
      <section class="eft-block">
        <div class="eft-block__head">
          <span class="eft-block__icon"><i class="fa fa-shield"></i></span>
          <div>
            <h4 class="eft-block__title">Команда</h4>
            <p class="eft-block__sub">Название и дисциплина</p>
          </div>
        </div>

        <div class="tf-grid">
          <div class="tf-field tf-field--8">
            <label class="tf-label tf-label--req" for="fake-team-name">Название</label>
            <b-form-input id="fake-team-name" v-model="formModel.name" type="text"
                          placeholder="Например: Bots Alpha" required
                          :state="formModel.name ? isNameValid : null"/>
            <div class="tf-hint">Минимум 2 символа.</div>
          </div>

          <div class="tf-field tf-field--4">
            <label class="tf-label" for="fake-team-game">Дисциплина</label>
            <b-form-select id="fake-team-game" v-model="formModel.game_id" :options="gamesForSelect"/>
            <div class="tf-hint">От неё зависит, какой игровой профиль правится ниже.</div>
          </div>
        </div>
      </section>

      <!-- ============ логотип ============ -->
      <section class="eft-block">
        <div class="eft-block__head">
          <span class="eft-block__icon"><i class="fa fa-picture-o"></i></span>
          <div>
            <h4 class="eft-block__title">Логотип</h4>
            <p class="eft-block__sub">Квадратная картинка, показывается в сетке турнира</p>
          </div>
        </div>

        <div class="eft-logo">
          <div class="eft-logo__preview">
            <img v-if="logoPreview" :src="logoPreview" alt="Логотип команды"/>
            <span v-else class="eft-logo__empty"><i class="fa fa-shield"></i></span>
          </div>

          <div class="eft-logo__control">
            <b-form-file id="select-image" ref="default"
                         placeholder="Файл не выбран"
                         drop-placeholder="Отпустите изображение"
                         browse-text="Выбрать"
                         accept="image/*"
                         @change="loadLogoForTeam"/>
            <div class="tf-hint">Новый файл заменит текущий логотип после сохранения.</div>
          </div>
        </div>
      </section>

      <!-- ============ состав ============ -->
      <section class="eft-block">
        <div class="eft-block__head">
          <span class="eft-block__icon"><i class="fa fa-users"></i></span>
          <div>
            <h4 class="eft-block__title">Состав</h4>
            <p class="eft-block__sub">Фейковые игроки и их игровые данные</p>
          </div>
          <span class="tf-badge">{{ formModel.members.length }}</span>
        </div>

        <div v-if="!formModel.members.length" class="eft-empty">
          В команде пока нет игроков — добавьте первого.
        </div>

        <div v-else class="eft-members">
          <div v-for="(member, index) in formModel.members" :key="'memberId' + member.id" class="eft-member">
            <div class="eft-member__head">
              <span class="eft-member__num">{{ index + 1 }}</span>
              <span class="eft-member__title">Игрок #{{ member.id }}</span>
              <span class="eft-member__spacer"></span>
              <button type="button" class="eft-member__del"
                      :disabled="isLoadingDeleteFakeUser"
                      @click="deleteFakeUser(member.id)"
                      v-b-tooltip.hover.top="'Удалить игрока из команды'">
                <i class="fa" :class="isLoadingDeleteFakeUser ? 'fa-spinner tf-spin' : 'fa-trash-o'"></i>
              </button>
            </div>

            <GameProfile :gameProfile="getGameProfile(member)"/>
          </div>
        </div>

        <button type="button" class="tf-btn-ghost eft-add"
                :disabled="isLoadingCreateFakeUser" @click="createFakeUser">
          <i class="fa" :class="isLoadingCreateFakeUser ? 'fa-spinner tf-spin' : 'fa-user-plus'"></i>
          {{ isLoadingCreateFakeUser ? 'Создаём…' : 'Добавить фейк-игрока' }}
        </button>
      </section>

      <div v-if="errorText" class="tf-alert eft-error">
        <i class="fa fa-exclamation-triangle tf-alert__icon"></i>
        <div class="tf-alert__body">{{ errorText }}</div>
      </div>

      <div class="eft-footer">
        <button type="button" class="tf-btn-ghost" @click="$emit('closeModal')">Отмена</button>
        <button type="submit" class="tf-btn-primary" :disabled="isLoadingSaveForm || !isNameValid">
          <i class="fa" :class="isLoadingSaveForm ? 'fa-spinner tf-spin' : 'fa-check'"></i>
          {{ isLoadingSaveForm ? 'Сохраняем…' : 'Сохранить' }}
        </button>
      </div>
    </b-form>
  </div>
</template>

<script>
import api from "@/api/api";
import {mapGetters} from "vuex";
import GameProfile from "@/components/FakeUserGameProfile.vue";
import {uploadedImage} from "@/common/imageUtils";

export default {
  name: "EditFakeTeam",
  components: {GameProfile},
  props: {
    params: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      uploadedImage,
      isLoadingSaveForm: false,
      errorText: '',
      formModel: {
        name: '',
        game_id: 0,
        members: [],
        logo: {original_url: ''}
      },
      isLoadingGames: false,
      isLoadingCreateFakeUser: false,
      isLoadingDeleteFakeUser: false,
    }
  },
  created() {
    (async () => {
      this.isLoadingGames = true
      await this.$store.dispatch('moduleFakeTeams/getGames')
      await this.getDefaultData()
      this.isLoadingGames = false
    })()
  },
  computed: {
    ...mapGetters('moduleFakeTeams', ['gamesForSelect']),

    isNameValid() {
      return typeof this.formModel.name === 'string' && this.formModel.name.trim().length >= 2
    },

    /** Пока файл не загружен, показываем текущий логотип; после выбора — превью нового. */
    logoPreview() {
      return uploadedImage(this.formModel.logo && this.formModel.logo.original_url)
    },
  },
  methods: {
    async submitForm(event) {
      try {
        event.preventDefault()
        this.isLoadingSaveForm = true
        this.errorText = null

        const formData = new FormData()
        formData.append("name", this.formModel.name)
        formData.append("game_id", this.formModel.game_id)
        const imageFile = this.$refs.default.$el.children[0].files[0]
        if (imageFile) formData.append('logo', imageFile)

        await api.fakeTeams.update(this.params.id, formData)

        await this.$store.dispatch('moduleFakeTeams/getFakeTeams', {
          page: localStorage.getItem('pageNumberFakeTeams'),
        })

        this.$emit('closeModal')
      } catch (e) {
        this.errorText = this.readError(e, 'Не удалось сохранить команду')
      } finally {
        this.isLoadingSaveForm = false
      }
    },

    async getDefaultData() {
      const fakeTeam = await this.$store.dispatch('moduleFakeTeams/getDefaultDataForFakeTeam', this.params.id)
      this.formModel.name = fakeTeam.name
      this.formModel.game_id = fakeTeam.game_id
      this.formModel.members = fakeTeam.members.map(({id, game_profiles}) => ({id, game_profiles}))
      this.formModel.logo = fakeTeam.logo || {original_url: ''}
    },

    getGameProfile(member) {
      return member.game_profiles.find(({game_id}) => game_id === this.formModel.game_id) || {}
    },

    async createFakeUser() {
      try {
        this.isLoadingCreateFakeUser = true
        this.errorText = null
        await api.fakeUsers.store({team_id: this.params.id})
        await this.getDefaultData()
        await this.$store.dispatch('moduleFakeTeams/getFakeTeams', {
          page: localStorage.getItem('pageNumberFakeTeams'),
        })
      } catch (e) {
        this.errorText = this.readError(e, 'Не удалось создать игрока')
      } finally {
        this.isLoadingCreateFakeUser = false
      }
    },

    async deleteFakeUser(id) {
      try {
        this.isLoadingDeleteFakeUser = true
        this.errorText = null
        await api.fakeUsers.delete(id)
        await this.getDefaultData()
        await this.$store.dispatch('moduleFakeTeams/getFakeTeams', {
          page: localStorage.getItem('pageNumberFakeTeams'),
        })
      } catch (e) {
        this.errorText = this.readError(e, 'Не удалось удалить игрока')
      } finally {
        this.isLoadingDeleteFakeUser = false
      }
    },

    loadLogoForTeam(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      this.formModel.logo = {...this.formModel.logo, original_url: file}
    },

    /** Раньше падало на e.response.data.message, если ответа не было вовсе. */
    readError(error, fallback) {
      const data = error && error.response && error.response.data
      return (data && data.message) || fallback
    },
  },
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/tournament-form.scss";

.eft {
  display: block;
}

/* ---------- блоки ---------- */
.eft-block {
  & + & {
    margin-top: 18px;
    padding-top: 18px;
    border-top: 1px solid var(--tf-border);
  }

  &__head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 10px;
    background: var(--tf-primary-soft);
    color: var(--tf-primary);
    font-size: 12px;
    flex: 0 0 auto;
  }

  &__title {
    margin: 0;
    font-size: 13.5px;
    font-weight: 600;
    color: var(--tf-text);
  }

  &__sub {
    margin: 1px 0 0;
    font-size: 11.5px;
    color: var(--tf-muted);
  }
}

/* ---------- логотип ---------- */
.eft-logo {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  &__preview {
    width: 84px;
    height: 84px;
    flex: 0 0 auto;
    border-radius: 24px;
    overflow: hidden;
    background: var(--tf-soft);
    border: 1px solid var(--tf-border);

    img { width: 100%; height: 100%; object-fit: cover; }
  }

  &__empty {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: var(--tf-muted);
    font-size: 22px;
  }

  &__control {
    flex: 1 1 220px;
    min-width: 0;
  }
}

/* ---------- состав ---------- */
.eft-members {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.eft-member {
  border: 1px solid var(--tf-border);
  border-radius: 12px;
  background: var(--tf-soft);
  padding: 12px 14px;

  &__head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;
  }

  &__num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 7px;
    background: var(--tf-primary-soft);
    color: var(--tf-primary);
    font-size: 11px;
    font-weight: 700;
  }

  &__title {
    font-size: 12.5px;
    font-weight: 600;
    color: var(--tf-text);
  }

  &__spacer { flex: 1 1 auto; }

  &__del {
    width: 28px;
    height: 28px;
    border: 1px solid var(--tf-border);
    border-radius: 9px;
    background: var(--tf-bg);
    color: var(--tf-muted);
    font-size: 12px;
    cursor: pointer;

    &:hover:not(:disabled) {
      border-color: var(--tf-danger);
      background: var(--tf-danger-soft);
      color: var(--tf-danger);
    }

    &:disabled { opacity: .5; cursor: not-allowed; }
  }

  /* поля игрового профиля внутри карточки участника */
  ::v-deep .grid-mini-inputs {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 0 12px;
  }

  ::v-deep label {
    font-size: 11.5px;
    font-weight: 600;
    color: var(--tf-text);
    margin-bottom: 4px;
  }

  ::v-deep .btn {
    height: 32px;
    padding: 0 12px;
    border-radius: 9px;
    font-size: 12.5px;
  }
}

.eft-empty {
  padding: 20px;
  border: 1px dashed var(--tf-border);
  border-radius: 12px;
  background: var(--tf-soft);
  color: var(--tf-muted);
  font-size: 13px;
  text-align: center;
}

.eft-add {
  margin-top: 12px;
  width: 100%;
  justify-content: center;
}

/* ---------- подвал ---------- */
.eft-error { margin-top: 16px; }

.eft-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--tf-border);
}

/* ---------- скелетон ---------- */
.eft-skeleton {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.eft-sk {
  display: block;
  border-radius: 10px;
  background: linear-gradient(90deg, var(--tf-soft) 25%, var(--tf-soft-2) 37%, var(--tf-soft) 63%);
  background-size: 400% 100%;
  animation: eft-shimmer 1.3s ease infinite;

  &--row { height: 56px; }
  &--logo { height: 84px; }
}

@keyframes eft-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}
</style>
